import React from 'react'
import { ListerComponent } from 'client/fragments/listerFragment/components/ListerComponent'
import { Provider } from 'react-redux'
import { NoResultsComponent } from 'client/fragments/listerFragment/components/NoResultComponent'
import { chemistryTheme } from 'chemistry'
import { ChakraProvider } from '@chakra-ui/react'
import { TranslateContextProvider } from 'client/common/translator'
import { generateStore } from 'client/fragments/listerFragment/store/store'
import { NotFoundComponent } from 'client/fragments/listerFragment/components/NotFoundComponent'

function enrichProps(props) {
  return {
    ...props,
    sort: props.sort || [],
    mode: props.mode,
    zeroResults: !props.products?.collection?.length,
    searchResultType: props?.meta?.resultType,
    loading: false
  }
}

const createStore = props => generateStore({ data: enrichProps(props) })

const Component = props => {
  const { translations, term, collectionId, format } = props
  if (props.status === 404) return <NotFoundComponent {...{ translations, format }} />
  if (!props.products) return <NoResultsComponent {...{ collectionId, translations, term }} />
  const enrichedProps = enrichProps(props)
  const { store } = createStore(enrichedProps)
  return (
    <ChakraProvider resetCSS={false} theme={chemistryTheme}>
      <Provider store={store}>
        <TranslateContextProvider translations={store.getState().data.translations}>
          <ListerComponent {...enrichedProps} />
        </TranslateContextProvider>
      </Provider>
    </ChakraProvider>
  )
}

export default { Component }
